/* eslint-disable @typescript-eslint/no-explicit-any */
import callApi from 'lib/callApi';
import validateFieldForPlaceholder from 'lib/validateFieldPlaceholder';
import validator from 'validator';

export function getExportCsvUrlParams(
  companyId: number,
  ordering: string,
  server_or_workstation: string,
  searchData: string,
  checkedHostIds: number[],
  selectedCloudAgentsFilter: string,
  csv_type?: string,
) {
  if (companyId === -1) return '';
  const params = {
    company: companyId,
    search: searchData,
  };
  if (checkedHostIds?.length > 0) {
    params['host_id_list'] = checkedHostIds;
  }
  if (ordering && ordering !== 'name') {
    params['ordering'] = `${ordering},name`;
  }
  if (selectedCloudAgentsFilter) {
    params['filter'] = selectedCloudAgentsFilter;
  }
  if (csv_type && csv_type !== '') {
    params['csv_type'] = csv_type;
  }
  if (server_or_workstation && server_or_workstation !== '') {
    if (['Server', 'Workstations'].includes(server_or_workstation)) {
      params['server_or_workstation'] = server_or_workstation;
    } else {
      params['agentkey__activation_key'] = server_or_workstation;
    }
  }

  return params;
}

export async function loadCloudAgentsData(
  company_id: number,
  pageSize: number,
  currentPage: number,
  ordering: string,
  server_or_workstation: string,
  search_data: string,
  selectedCloudAgentsFilter: string,
): Promise<any> {
  if (company_id === undefined) {
    throw Error('company_id is required.');
  }

  // if company_id is not yet available then do not proceed further
  if (company_id === -1) return;

  if (ordering && ordering !== 'name') ordering = `${ordering},name`;

  let url = `cloud_agents/?company=${company_id}&filter=${selectedCloudAgentsFilter}&search=${search_data}&offset=${
    pageSize * (currentPage - 1)
  }&limit=${pageSize}&ordering=${ordering}`;

  if (server_or_workstation && server_or_workstation !== '') {
    if (['Server', 'Workstations'].includes(server_or_workstation)) {
      url += '&server_or_workstation=' + server_or_workstation;
    } else {
      url += '&agentkey__activation_key=' + server_or_workstation;
    }
  }

  const data = await callApi(url, 'GET', {})
    .then((res) => {
      if ((res.status === 201 || res.status === 200) && res.data.results) {
        return {
          items: res.data.results,
          count: res.data.count,
        };
      } else {
        // eslint-disable-next-line no-console
        console.error({
          function: 'loadCloudAgentsData',
          error: `Unexpected response: ${res.status}`,
          res,
        });
      }
      // setHistoricalData(data?.data.historical_data);
    })
    .catch((err) => {
      // this.setState({ loader: false });
      throw err;
    });

  return data;
}

export async function fetchCADetail(id) {
  let url = `cloud_agents/${id}/`;
  const data = await callApi(url, 'GET', {})
    .then((res) => {
      if (res.data) {
        return res.data;
      }
    })
    .catch((err) => {
      throw err;
    });
  return data;
}

export function parseNetworkList(networkList) {
  const rows: any = [];

  if (networkList && networkList.length > 0) {
    const firstItem = networkList[0]; // Assuming at least one item is present in the data array
    const childNode = Object.keys(firstItem)[0];
    networkList.forEach((item) => {
      const macAddress = item[childNode]['macAddress'];
      const ipv4 = validator.isIP(item[childNode]['address'], 4)
        ? item[childNode]['address']
        : validateFieldForPlaceholder('');
      const ipv6 = validator.isIP(item[childNode]['address'], 6)
        ? item[childNode]['address']
        : validateFieldForPlaceholder('');

      let existingRow = rows.find(
        (row) => row[childNode].macAddress === macAddress,
      );
      if (existingRow) {
        // Update the existing row with the IPv4 or IPv6 address
        existingRow[childNode].ipv4 =
          ipv4 !== validateFieldForPlaceholder('')
            ? ipv4
            : existingRow[childNode].ipv4;
        existingRow[childNode].ipv6 =
          ipv6 !== validateFieldForPlaceholder('')
            ? ipv6
            : existingRow[childNode].ipv6;
      } else {
        // Add a new row
        rows.push({
          [childNode]: {
            interfaceName: item[childNode]['interfaceName'],
            macAddress: macAddress,
            ipv4: ipv4,
            ipv6: ipv6,
            gatewayAddress: item[childNode]['gatewayAddress'],
          },
        });
      }
    });
  }
  const networkData = {
    network_interface: {
      list: rows,
    },
  };
  return networkData;
}
